import { computed } from "vue";
import { getToastState, dismissToast } from "@/services/toast.service.js";
import { toastService } from "@/services/toast.service.js";

export function useToast() {
  const state = getToastState();
  const toasts = computed(() => state.toasts);

  return {
    toasts,
    dismiss: dismissToast,
    success: toastService.success,
    error: toastService.error,
    info: toastService.info,
    warning: toastService.warning,
  };
}
